import {
  AUTH_TOKEN_SET,
  AUTH_REDIRECT_SET,
  AUTH_LOGOUT,
} from '../actions/types';
import {createReducer} from '../utils';

const initialState = {
  isAuthenticated: false,
  token: null,
};

const authReducer = createReducer(initialState, {
  [AUTH_TOKEN_SET]: (state, payload) => {
    const {token} = payload;
    return {
      ...state,
      isAuthenticated: true,
      token,
    };
  },
  [AUTH_REDIRECT_SET]: (state, payload) => {
    const {path: redirectAfterLogIn} = payload;
    return {
      ...state,
      redirectAfterLogIn,
    };
  },
  [AUTH_LOGOUT]: () => initialState,
});

export default authReducer;
